import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ItemCard from "@/components/ItemCard";
import { Crown, DownloadSimple, ChartLineUp } from "@phosphor-icons/react";

export default function Account() {
  const { user, login } = useAuth();
  const [downloads, setDownloads] = useState([]);

  useEffect(() => {
    if (user) api.get("/my/downloads").then((r) => setDownloads(r.data)).catch(() => {});
  }, [user]);

  if (!user) {
    return (
      <div className="grid-bg min-h-[70vh] flex items-center justify-center px-5">
        <div className="text-center">
          <p className="text-white/60 mb-6">Sign in to view your account.</p>
          <button onClick={login} className="bg-[#FFEB3B] text-[#05050A] font-bold px-6 py-3 rounded-sm">Sign In</button>
        </div>
      </div>
    );
  }

  return (
    <div className="grid-bg min-h-screen">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-16">
        <div className="glass rounded-2xl p-8 flex flex-col sm:flex-row items-center gap-6" data-testid="account-header">
          <img src={user.picture || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || "U")}&background=00E5FF&color=05050A`}
            alt="" className="w-20 h-20 rounded-full border-2 border-white/20" />
          <div className="text-center sm:text-left">
            <h1 className="font-display font-black text-2xl uppercase tracking-tight">{user.name}</h1>
            <p className="text-white/50">{user.email}</p>
            <div className="flex items-center gap-2 mt-3 justify-center sm:justify-start">
              {user.is_premium ? (
                <span className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-[#FFEB3B] text-glow-yellow">
                  <Crown weight="fill" size={16} /> Premium Member
                </span>
              ) : (
                <Link to="/premium" className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-[#00E5FF] hover:underline">
                  <Crown size={16} /> Upgrade to Premium
                </Link>
              )}
              {user.is_admin && <span className="text-xs font-bold uppercase tracking-wider text-[#FF00AA]">Admin</span>}
            </div>
          </div>
        </div>

        {user.is_admin && (
          <Link to="/submit" data-testid="creator-studio-link"
            className="mt-8 glass rounded-2xl p-6 flex items-center justify-between gap-4 hover:border-[#00E5FF]/40 transition-colors">
            <div className="flex items-center gap-3">
              <ChartLineUp weight="bold" size={22} className="text-[#00E5FF]" />
              <div>
                <h3 className="font-display font-bold uppercase tracking-tight">Creator Earnings</h3>
                <p className="text-white/50 text-sm mt-1">View downloads and payout totals for your packs.</p>
              </div>
            </div>
            <span className="text-[#00E5FF] font-bold text-sm shrink-0">Open →</span>
          </Link>
        )}

        <div className="mt-12">
          <h2 className="font-display font-bold text-xl uppercase tracking-tight flex items-center gap-2 mb-6">
            <DownloadSimple size={22} /> Your Downloads
          </h2>
          {downloads.length === 0 ? (
            <p className="text-white/40">No downloads yet. <Link to="/marketplace" className="text-[#00E5FF] hover:underline">Grab some packs.</Link></p>
          ) : (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
              {downloads.map((it) => <ItemCard key={it.id} item={it} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
